import { BigNumber } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTupleArray, FctValueList } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { kiroboMulticallContracts } from '../constants';
export var MultiBalanceCSV = createPlugin({
    protocol: 'KIROBO_MULTICALL_CSV',
    type: 'LIBRARY:VIEWONLY',
    toEns: '@lib:multicall',
    method: 'multiBalance',
    name: 'multiBalanceCSV',
    supportedContracts: kiroboMulticallContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    'balances_tuple[]': new FctTupleArray({
                        params: {
                            token: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }) }),
                            account: new FctAddressList({}),
                        },
                    }),
                },
            },
            output: {
                balances: new FctValueList({}),
            },
        });
    },
    estimateGasOnParams: function (params, method, chainId) {
        var balances = params.methodParams['balances_tuple[]'];
        if (!balances.value || !Array.isArray(balances.value)) {
            return '10000';
        }
        var gas = BigNumber.from(balances.value.length).mul(BigNumber.from(7000));
        if (chainId === '42161') {
            gas = gas.mul(BigNumber.from(13));
        }
        return gas.toString();
    },
});
